import * as actions from "./api";
import { call, put } from "redux-saga/effects";

export function* fetchMember(action) {
  try {
    const req = yield call(actions.fetchMember, action.payload);
    yield put({ type: "FETCH_MEMBER_SUCCESS", payload: req });
  } catch (error) {
    // if (checkOnlineAndToken(error)) {
    yield put({ type: "FETCH_MEMBER_FAILED", payload: error });
    // }
  }
}

export function* fetchCities(action) {
  try {
    const req = yield call(actions.fetchLocation, action.payload);
    yield put({ type: "FETCH_CITIES_SUCCESS", payload: req.data });
  } catch (error) {
    // if (checkOnlineAndToken(error)) {
    yield put({ type: "FETCH_CITIES_FAILED", payload: error });
    // }
  }
}

export function* fetchUsers(action) {
  try {
    const req = yield call(actions.fetchUsers, action.payload);
    yield put({ type: "FETCH_USERS_SUCCESS", payload: req && req.data });
  } catch (error) {
    // if (checkOnlineAndToken(error)) {
    yield put({ type: "FETCH_USERS_FAILED", payload: error });
    // }
  }
}

export function* fetchPromotions(action) {
  try {
    const req = yield call(actions.fetchPromotions, action.payload);
    yield put({ type: "FETCH_PROMOTIONS_SUCCESS", payload: req && req.data });
  } catch (error) {
    // if (checkOnlineAndToken(error)) {
    yield put({ type: "FETCH_PROMOTIONS_FAILED", payload: error });
    // }
  }
}

export function* fetchDetailPromotion(action) {
  try {
    const req = yield call(actions.fetchDetailPromotion, action.payload);
    yield put({ type: "FETCH_DETAIL_PROMOTION_SUCCESS", payload: req });
  } catch (error) {
    // if (checkOnlineAndToken(error)) {
    yield put({ type: "FETCH_DETAIL_PROMOTION_FAILED", payload: error });
    // }
  }
}

export function* fetchGroupProduct(action) {
  try {
    const req = yield call(actions.fetchGroupProduct, action.payload);
    yield put({
      type: "FETCH_GROUP_PRODUCT_SUCCESS",
      payload: req && req.data,
    });
  } catch (error) {
    // if (checkOnlineAndToken(error)) {
    yield put({ type: "FETCH_GROUP_PRODUCT_FAILED", payload: error });
    // }
  }
}

export function* fetchNotifications(action) {
  try {
    const req = yield call(actions.fetchNotifications, action.payload);
    yield put({
      type: "FETCH_NOTIFICATIONS_SUCCESS",
      payload: req && req.data,
    });
  } catch (error) {
    // if (checkOnlineAndToken(error)) {
    yield put({ type: "FETCH_NOTIFICATIONS_FAILED", payload: error });
    // }
  }
}

export function* fetchUserGroup(action) {
  try {
    const res = yield call(actions.getUserGroup, action.pag);
    yield put({ type: "FETCH_USER_GROUP_SUCCESS", payload: res.data });
  } catch (error) {
    yield put({ type: "FETCH_USER_GROUP_FAIL", payload: error });
  }
}
export function* fetchUserGroupDetail(action) {
  try {
    const res = yield call(actions.getUserGroupDetail, +action.action);

    yield put({ type: "FETCH_USER_GROUP_DETAIL_SUCCESS", payload: res.data });
  } catch (error) {
    yield put({ type: "FETCH_USER_GROUP_DETAIL_FAIL", payload: error });
  }
}
export function* fetchPermissionByGroup(action) {
  try {
    const res = yield call(actions.getPermissionByGroup, action.action);
    yield put({
      type: "FETCH_PERMISSION_BY_GROUP_SUCCESS",
      payload: res.data.data,
    });
  } catch (error) {
    yield put({ type: "FETCH_PERMISSION_BY_GROUP_FAIL", payload: error });
  }
}
export function* fetchPermissionUser(action) {
  try {
    const res = yield call(actions.getPermissionUser, +action.action);
    yield put({ type: "FETCH_PERMISSION_USER_SUCCESS", payload: res.data });
  } catch (error) {
    yield put({ type: "FETCH_PERMISSION_USER_FAIL", payload: error });
  }
}
export function* fetchPermission(action) {
  try {
    const res = yield call(actions.getPermissionUser, +action.action);
    yield put({ type: "FETCH_PERMISSION_SUCCESS", payload: res.data });
  } catch (error) {
    yield put({ type: "FETCH_PERMISSION_FAIL", payload: error });
  }
}
